export default __webpack_public_path__ + "static/media/(22).775a39ff.jpg";